import React, { Component } from "react";

import PropTypes from "prop-types";
//import axios from "axios";

export class AboutItem extends Component {
  state = {
    imgUrl: "",
    imgUrlTh: "",
    imgUrlMd: "",
    imgUrlLg: "",
    imgUrlMdLg: "",
    imgUrl600: "",
    imgUrl900: "",
    imgUrl2000: ""
    
  };
  static propTypes = {
    about: PropTypes.object.isRequired,
  };

  

  render() {
      //@ts-ignore
    const { slug, title, content, acf } = this.props.about;
    //const { imgUrl, imgUrlMd, imgUrlLg, imgUrlMdLg, imgUrl600, imgUrl900, imgUrl2000 } = this.state;
    
    
      return (
        <section id={slug} className="ob-about">
          <img className="fix-img" src="https://obrien365.com/ob-wp/wp-content/uploads/2020/11/OBrien-About-Background-big.jpg" srcSet="https://obrien365.com/ob-wp/wp-content/uploads/2020/11/OBrien-About-Background-big-300x282.jpg 300w, https://obrien365.com/ob-wp/wp-content/uploads/2020/11/OBrien-About-Background-big-1024x961.jpg 1024w, https://obrien365.com/ob-wp/wp-content/uploads/2020/11/OBrien-About-Background-big-768x721.jpg 768w, https://obrien365.com/ob-wp/wp-content/uploads/2020/11/OBrien-About-Background-big-630x591.jpg 630w, https://obrien365.com/ob-wp/wp-content/uploads/2020/11/OBrien-About-Background-big-960x901.jpg 960w, https://obrien365.com/ob-wp/wp-content/uploads/2020/11/OBrien-About-Background-big-2048x1922.jpg 2048w" alt={title.rendered} />
          <div className="text-container inside-xl">
            <div>
              <div dangerouslySetInnerHTML={{ __html: content.rendered }}></div>
              <div className="around-button"><span className="myButton"><a className="button" href={acf.button_link}>{acf.button_text}</a></span></div>
            </div>
          </div>
          
        </section>
      );
    
  }
}

export default AboutItem;
